// extracted by mini-css-extract-plugin
module.exports = {"freeShipping":"FreeShipping_freeShipping__xQitx"};